import type { SubscriptionsState } from './types'

const state = (): SubscriptionsState => ({
  SKUMetadata: null,
  subscriptions: [],
  genericTSILink: [],
  website: [],
  basic: [],
  premium: [],
  websiteQtyRemainingBlueSky: 0,
  websiteQtyUsedBlueSky: 0,
  websiteQtyRemainingBlueSkyGas: 0,
  websiteQtyUsedBlueSkyGas: 0,
  websiteQtyRemainingAirAssure: 0,
  websiteQtyUsedAirAssure: 0,
  basicQtyRemainingBlueSky: 0,
  basicQtyRemainingAirAssure: 0,
  premiumQtyRemainingBlueSky: 0,
  premiumQtyRemainingBlueSkyGas: 0,
  premiumQtyRemainingAirAssure: 0,
  dataServices: [],
  deviceWebsite: null,
  deviceGeneric: null,
  deviceBasic: null,
  devicePremium: null,
  deviceDataServices: null,
  permissionsInRole: {}
})

export default state
